import { unorphanLast } from './unorphan';
export var oneLine = function oneLine(str) {
  return str.replace(/\n/g, ' ').trim();
};
export var oneLineTrim = function oneLineTrim(str) {
  return str.replace(/\s/g, '').trim();
};
export var oneLineUnorphan = function oneLineUnorphan(input) {
  return unorphanLast(oneLine(input));
};